import React, { FC } from 'react';
import { RoleAction } from '@wix/members-domain-ts';

import {
  InjectedTranslateProps,
  AdditionalAction,
  DataHook,
  Position,
} from '../../../types';
import MoreButton from '../MoreButton';
import PopoverContent, {
  OnAdditionalAction,
  OnRoleAction,
} from './PopoverContent';

interface MemberMoreButtonProps extends InjectedTranslateProps {
  containerClass: string;
  iconContainerClass?: string;
  additionalActions: AdditionalAction[];
  rolesActions: RoleAction[];
  position?: Position;
  alignment: Position;
  isMobile: boolean;
  isRtlLocale: boolean;
  isDisabled?: boolean;
  dynamicPositioning?: boolean;
  onAdditionalAction: OnAdditionalAction;
  onRoleAction: OnRoleAction;
}

const MemberMoreButton: FC<MemberMoreButtonProps> = ({
  containerClass,
  iconContainerClass = '',
  additionalActions,
  rolesActions,
  position,
  alignment,
  isMobile,
  isRtlLocale,
  isDisabled,
  dynamicPositioning = false,
  t,
  onAdditionalAction,
  onRoleAction,
}) => {
  if (!rolesActions.length && !additionalActions.length) {
    return null;
  }

  return (
    <div data-hook={DataHook.MoreActionsWrapper} className={containerClass}>
      <MoreButton
        iconContainerClass={iconContainerClass}
        dynamicPositioning={dynamicPositioning}
        position={position}
        alignment={alignment}
        isRtlLocale={isRtlLocale}
        isMobile={isMobile}
        isDisabled={isDisabled}
        t={t}
      >
        <PopoverContent
          additionalActions={additionalActions}
          rolesActions={rolesActions}
          isMobile={isMobile}
          t={t}
          onAdditionalAction={onAdditionalAction}
          onRoleAction={onRoleAction}
        />
      </MoreButton>
    </div>
  );
};

export default MemberMoreButton;
